import { dateSchema } from "components/form/utils";
import { z } from "zod";


export const quadrimesterSchema = z.object({
  name: z.string().min(1, "Name is required"),
  start_date: dateSchema,
  end_date: dateSchema,
  status: z.string().min(1, "Status is required"),
  allow_self_nomination: z.boolean().optional().default(true),
}).refine((data) => (data.start_date && data.end_date ? data.end_date >= data.start_date : true), {
  path: ["end_date"],
  message: "End date cannot be before start date",
});